import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { navSelector } from 'common/store/modules/competition-nav/selectors';
import { useGetMatchesQuery } from 'common/store/modules/api/afl-api';
import { CardItem } from './CardItem';
import { MatchSkeleton } from './MatchSkeleton';
import { useGroupMatches } from 'common/react/hooks/use-group-matches';

export const BroadcastGuideCards = ({ seasonId, competitionId }) => {
    const nav = useSelector(navSelector);
    const round = nav?.round.roundNumber;
    const location = nav?.location;

    const params = {
        competition: competitionId,
        compSeasonId: seasonId,
        roundNumber: round,
        pageSize: 100
    };

    const { data: matches = [], isFetching: isMatchesFetching } =
        useGetMatchesQuery(params);

    const matchItems = useGroupMatches(matches, location.timezone);

    if (isMatchesFetching) {
        return <MatchSkeleton />;
    }

    return (
        <>
            {matchItems?.length
                ? matchItems.map((item, index) => (
                      <CardItem
                          key={
                              typeof item === 'string'
                                  ? `${item}-${index}`
                                  : item.id
                          }
                          item={item}
                          location={location}
                          competitionId={competitionId}
                          seasonId={seasonId}
                      />
                  ))
                : ''}
        </>
    );
};

BroadcastGuideCards.propTypes = {
    seasonId: PropTypes.string,
    competitionId: PropTypes.string
};
